import type { CornerstoneImage } from '../../../utils/cornerstone/useCornerstone';
import type { BoundingBoxFinding, SliderRange, UserAnnotation } from '../types';

export const isWithinSensitivityRange = (
  finding: BoundingBoxFinding | UserAnnotation,
  image: CornerstoneImage,
  desiredVisibleBoxSizeRange: SliderRange = [0, 0],
): boolean => {
  if (!finding) {
    return false;
  }
  const { imageDimension } = image;

  const { heightPx: imgHeight, widthPx: imgWidth } = imageDimension ?? {
    // A common width/height for images based upon a random sampling of images from an FMX
    // This shouldn't really be needed, because a finding should *always* find the related image, but added as a "just in case"
    widthPx: 1920,
    heightPx: 1440,
  };
  const findingWidth = finding.xMax - finding.xMin;
  const findingHeight = finding.yMax - finding.yMin;

  const findingSizePercentageRelativeToImageSize =
    (100 * (findingWidth * findingHeight)) / (imgWidth * imgHeight);

  const [minimumBoxSize, maximumBoxSize] = desiredVisibleBoxSizeRange;
  return (
    findingSizePercentageRelativeToImageSize > minimumBoxSize &&
    findingSizePercentageRelativeToImageSize < maximumBoxSize
  );
};
